import axiosInstance from "../../translator";
import { addressApi, webSocket } from "../../constants/apis/apiEndpoints";

export const fetchAddressList = async (urlParams) => {
  return axiosInstance
    .get(`${addressApi.address}${urlParams}`)
    .then((response) => {
      return response?.data;
    })
    .catch((error) => {
      return error;
    });
};

export const webSocketTicket = async (path) => {
  return axiosInstance
    .post(`${webSocket.ticket}`, path)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};
